import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    '& .react-multi-carousel-item': {
      paddingRight: theme.spacing(5),
      userSelect: 'none',
    },

    '& .swiper-slide': {
      width: theme.spacing(8.75),
    },

    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(0, 0, 2),
    },

    'swiper-slide': {
      width: theme.spacing(8.75),
      marginRight: theme.spacing(5),
    },
  },
}));
